import React, { useState, useEffect } from 'react';

// BangladeshLocation component
function BangladeshLocation() {
  // State variables to store data and selections
  const [divisions, setDivisions] = useState([]);
  const [selectedDivisionId, setSelectedDivisionId] = useState('');
  const [districts, setDistricts] = useState([]);
  const [selectedDistrictId, setSelectedDistrictId] = useState('');
  const [upazilas, setUpazilas] = useState([]);
  const [selectedUpazilaId, setSelectedUpazilaId] = useState('');
  const [unions, setUnions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Base URL for the API
  const API_BASE_URL = 'https://bdapi.vercel.app/api/v.1';

  // Fetch Divisions on component mount
  useEffect(() => {
    const fetchDivisions = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/division`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("বিভাগ API থেকে প্রাপ্ত ডেটা:", data);
        if (data && data.data) {
          setDivisions(data.data);
          console.log("সেট করা বিভাগ:", data.data);
        } else {
          setError("বিভাগের ডেটা অপ্রত্যাশিত ফরম্যাটে আছে।");
          console.error("বিভাগের ডেটা অপ্রত্যাশিত ফরম্যাটে আছে:", data);
        }
      } catch (err) {
        console.error("বিভাগ লোড করতে ব্যর্থ:", err);
        setError(`বিভাগ লোড করতে সমস্যা হয়েছে: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchDivisions();
  }, []);

  // Fetch Districts when selectedDivisionId changes
  useEffect(() => {
    const fetchDistricts = async () => {
      if (!selectedDivisionId) {
        setDistricts([]);
        setSelectedDistrictId('');
        setUpazilas([]);
        setSelectedUpazilaId('');
        setUnions([]);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_BASE_URL}/district/${selectedDivisionId}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log(`জেলা API থেকে প্রাপ্ত ডেটা (বিভাগ ID: ${selectedDivisionId}):`, data);
        if (data && data.data) {
          setDistricts(data.data);
          setSelectedDistrictId('');
          setUpazilas([]);
          setSelectedUpazilaId('');
          setUnions([]);
        } else {
          setError("জেলার ডেটা অপ্রত্যাশিত ফরম্যাটে আছে।");
          console.error("জেলার ডেটা অপ্রত্যাশিত ফরম্যাটে আছে:", data);
        }
      } catch (err) {
        console.error("জেলা লোড করতে ব্যর্থ:", err);
        setError(`জেলা লোড করতে সমস্যা হয়েছে: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchDistricts();
  }, [selectedDivisionId]);

  // Fetch Upazilas when selectedDistrictId changes
  useEffect(() => {
    const fetchUpazilas = async () => {
      if (!selectedDistrictId) {
        setUpazilas([]);
        setSelectedUpazilaId('');
        setUnions([]);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        // Assuming the correct API path for upazila is /upazilla/:districtId
        const response = await fetch(`${API_BASE_URL}/upazilla/${selectedDistrictId}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log(`উপজেলা API থেকে প্রাপ্ত ডেটা (জেলা ID: ${selectedDistrictId}):`, data);
        if (data && data.data) {
          setUpazilas(data.data);
          setSelectedUpazilaId('');
          setUnions([]);
        } else {
          setError("উপজেলার ডেটা অপ্রত্যাশিত ফরম্যাটে আছে।");
          console.error("উপজেলার ডেটা অপ্রত্যাশিত ফরম্যাটে আছে:", data);
        }
      } catch (err) {
        console.error("উপজেলা লোড করতে ব্যর্থ:", err);
        setError(`উপজেলা লোড করতে সমস্যা হয়েছে: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchUpazilas();
  }, [selectedDistrictId]);

  // Fetch Unions when selectedUpazilaId changes
  useEffect(() => {
    const fetchUnions = async () => {
      if (!selectedUpazilaId) {
        setUnions([]);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        // Assuming the correct API path for union is /union/:upazilaId
        const response = await fetch(`${API_BASE_URL}/union/${selectedUpazilaId}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log(`ইউনিয়ন API থেকে প্রাপ্ত ডেটা (উপজেলা ID: ${selectedUpazilaId}):`, data);
        if (data && data.data) {
          setUnions(data.data);
        } else {
          setError("ইউনিয়নের ডেটা অপ্রত্যাশিত ফরম্যাটে আছে।");
          console.error("ইউনিয়নের ডেটা অপ্রত্যাশিত ফরম্যাটে আছে:", data);
        }
      } catch (err) {
        console.error("ইউনিয়ন লোড করতে ব্যর্থ:", err);
        setError(`ইউনিয়ন লোড করতে সমস্যা হয়েছে: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchUnions();
  }, [selectedUpazilaId]);

  // Handle change for Division dropdown
  const handleDivisionChange = (event) => {
    setSelectedDivisionId(event.target.value);
  };

  // Handle change for District dropdown
  const handleDistrictChange = (event) => {
    setSelectedDistrictId(event.target.value);
  };

  // Handle change for Upazila dropdown
  const handleUpazilaChange = (event) => {
    setSelectedUpazilaId(event.target.value);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-400 to-blue-500 flex items-center justify-center p-4 font-sans">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-md transform transition-all duration-300 hover:scale-105">
        <h1 className="text-3xl font-extrabold text-center text-gray-800 mb-8">
          <span className="text-green-600">বাংলাদেশ</span> ভৌগোলিক তথ্য
        </h1>

        {loading && (
          <div className="flex items-center justify-center mb-4 text-blue-600 font-medium">
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            লোডিং হচ্ছে...
          </div>
        )}

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-4" role="alert">
            <strong className="font-bold">ত্রুটি!</strong>
            <span className="block sm:inline"> {error}</span>
          </div>
        )}

        <div className="space-y-6">
          {/* Division Dropdown */}
          <div>
            <label htmlFor="division-select" className="block text-gray-700 text-sm font-semibold mb-2">
              বিভাগ নির্বাচন করুন:
            </label>
            <div className="relative">
              <select
                id="division-select"
                className="block BangladeshLocationearance-none w-full bg-gray-50 border border-gray-300 text-gray-900 py-3 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-blue-500 transition-all duration-200 shadow-sm"
                value={selectedDivisionId}
                onChange={handleDivisionChange}
                disabled={loading}
              >
                <option value="">একটি বিভাগ নির্বাচন করুন</option>
                {divisions.map((division) => (
                  <option key={division.id} value={division.id}>
                    {division.bn_name}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>

          {/* District Dropdown */}
          <div>
            <label htmlFor="district-select" className="block text-gray-700 text-sm font-semibold mb-2">
              জেলা নির্বাচন করুন:
            </label>
            <div className="relative">
              <select
                id="district-select"
                className="block BangladeshLocationearance-none w-full bg-gray-50 border border-gray-300 text-gray-900 py-3 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-blue-500 transition-all duration-200 shadow-sm"
                value={selectedDistrictId}
                onChange={handleDistrictChange}
                disabled={!selectedDivisionId || loading}
              >
                <option value="">একটি জেলা নির্বাচন করুন</option>
                {districts.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.bn_name} {/* এখানে bn_name ব্যবহার করা হয়েছে */}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>

          {/* Upazila Dropdown */}
          <div>
            <label htmlFor="upazila-select" className="block text-gray-700 text-sm font-semibold mb-2">
              উপজেলা নির্বাচন করুন:
            </label>
            <div className="relative">
              <select
                id="upazila-select"
                className="block BangladeshLocationearance-none w-full bg-gray-50 border border-gray-300 text-gray-900 py-3 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-blue-500 transition-all duration-200 shadow-sm"
                value={selectedUpazilaId}
                onChange={handleUpazilaChange}
                disabled={!selectedDistrictId || loading}
              >
                <option value="">একটি উপজেলা নির্বাচন করুন</option>
                {upazilas.map((upazila) => (
                  <option key={upazila.id} value={upazila.id}>
                    {/* এখানেও upazila ডেটার ফরম্যাট bn_name আছে কিনা তা পরীক্ষা করে ব্যবহার করুন */}
                    {upazila.bn_name || upazila.name_bn}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>

          {/* Union Dropdown */}
          <div>
            <label htmlFor="union-select" className="block text-gray-700 text-sm font-semibold mb-2">
              ইউনিয়ন নির্বাচন করুন:
            </label>
            <div className="relative">
              <select
                id="union-select"
                className="block BangladeshLocationearance-none w-full bg-gray-50 border border-gray-300 text-gray-900 py-3 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-blue-500 transition-all duration-200 shadow-sm"
                value={selectedUpazilaId} // This should be selectedUnionId
                disabled={!selectedUpazilaId || loading}
              >
                <option value="">একটি ইউনিয়ন নির্বাচন করুন</option>
                {unions.map((union) => (
                  <option key={union.id} value={union.id}>
                    {/* এখানেও union ডেটার ফরম্যাট bn_name আছে কিনা তা পরীক্ষা করে ব্যবহার করুন */}
                    {union.bn_name || union.name_bn}
                  </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BangladeshLocation;